import React from 'react';
import {RootState} from "../../../../../../../../reducers";
import {getSession} from "../../../../../../../services/Session/reducer";
import {connect} from "react-redux";
import {useTranslation, withTranslation} from "react-i18next";
import {Link} from "react-router-dom";
import {ReactComponent as LeftIco} from "../../../../../../../../images/icons/arrow-left.svg";
import ResponsiveComponent from "../../../../../../../components/Common/ResponsiveComponent";
import {FormatAddressString} from "go-core/components/Formatters/FormatAddress";
import {ReactComponent as EditIco} from "../../../../../../../../images/icons/edit.svg";
import {ReactComponent as PlusIco} from "../../../../../../../../images/icons/plus.svg";

interface OwnProps {
    setShowAddressModal: React.Dispatch<React.SetStateAction<boolean>>;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const MultistoreMapPageNavbarLocation = ({session, setShowAddressModal}: Props) => {
    const {t} = useTranslation();

    return (
        <div className="d-flex w-100">
            <ResponsiveComponent small={
                <Link className="btn btn-back d-flex align-items-center justify-content-center" to="/">
                    <LeftIco/>
                </Link>
            } large={<></>} breakpoint={769}/>
            <button className="d-flex w-100 align-items-center location-container"
                    onClick={() => setShowAddressModal(true)}
                    aria-label={session.full_address ?
                    t("modules.multistore.action.edit_address.title") :
                    t("modules.multistore.action.set_address.title")}
            >
                <div className="d-flex flex-column justify-content-center w-100">
                    <h5>
                        {t("modules.multistore.field.choose_place.title")}
                    </h5>
                    <small
                        className={`${session.full_address ? "" : "text-muted"} fw-normal`}>
                        {session.full_address ? FormatAddressString(session.address) : t("modules.multistore.field.enter_address.title")}
                    </small>
                </div>
                <div className="btn btn-icon">
                    {session.full_address ? <EditIco aria-hidden="true" /> : <PlusIco aria-hidden="true" />}
                </div>
                </button>
        </div>
    )
}
const mapStateToProps = (state: RootState) => ({
    session: getSession(state.session)
});

const connector = connect(mapStateToProps);
export default withTranslation()(connector(MultistoreMapPageNavbarLocation));